import { render, staticRenderFns } from "./TopbarDropdown.vue?vue&type=template&id=87b6210a&scoped=true"
import script from "./TopbarDropdown.vue?vue&type=script&lang=ts"
export * from "./TopbarDropdown.vue?vue&type=script&lang=ts"
import style0 from "./TopbarDropdown.vue?vue&type=style&index=0&id=87b6210a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b6210a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87b6210a')) {
      api.createRecord('87b6210a', component.options)
    } else {
      api.reload('87b6210a', component.options)
    }
    module.hot.accept("./TopbarDropdown.vue?vue&type=template&id=87b6210a&scoped=true", function () {
      api.rerender('87b6210a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/TopbarDropdown.vue"
export default component.exports